class AppVersion {
	constructor() {
		this.Major = 2;
		this.Minor = 1;
		this.Build = 89;
		this.Date = '03/11/2026';
	}

	getVersion() {
		return 'v ' + this.Major + '.' + this.Minor + '.' + this.Build;
	}
}
const appVersion = new AppVersion();
export default appVersion;
